export enum FaultPageErrorType {
  MISSING_EULA = 'missing_eula',
  MISSING_PRIVACY_POLICY = 'missing_privacy_policy',
  INVALID_STUDY_CONFIGURATION = 'invalid_study_configuration',
}
